"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _router = require("@reach/router");

var _react = require("react");

/* eslint-disable no-underscore-dangle */
var loadStoryblokBridge = function loadStoryblokBridge() {
  return new Promise(function (resolve) {
    var accessToken = window.__STORYBLOK_ACCESSTOKEN__;

    if (!accessToken) {
      console.error('You didnt specify an accessToken for Storyblok in the @sb-konzept/gatsby-source-storyblok plugin configuration. This is required! Please add your accessToken to `./gatsby-config.js`.');
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "//app.storyblok.com/f/storyblok-latest.js?t=".concat(accessToken);
    script.onload = resolve;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

function useStory(storyblok) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      story = _useState2[0],
      setStory = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isInEditor = _useState4[0],
      setIsInEditor = _useState4[1];

  var storyRef = (0, _react.useRef)(null);
  storyRef.current = story;
  var loadStory = (0, _react.useCallback)(function (slug) {
    if (!storyblok) return null;
    return new Promise(function (resolve) {
      return storyblok.get({
        slug: slug,
        version: 'draft'
      }, function (data) {
        resolve(data.story);
        setStory(data.story);
      });
    });
  }, [storyblok]);
  var handleChangeOrPublish = (0, _react.useCallback)(function (payload) {
    window.localStorage.test = 'change';
    loadStory(payload.storyId);
  }, [loadStory]);
  var handleInput = (0, _react.useCallback)(function (payload) {
    window.localStorage.test = 'input';

    if (storyRef.current && payload.story.id === storyRef.current.id) {
      setStory((0, _objectSpread2["default"])({}, payload.story, {
        content: storyblok.addComments(payload.story.content, payload.story.id)
      }));
    } else {
      var previewPath = window.__STORYBLOK_PREVIEW_PATH__ || 'preview';
      (0, _router.navigate)("/".concat(previewPath, "/").concat(payload.story.full_slug));
    }
  }, [storyblok]);
  var setupEditor = (0, _react.useCallback)(function () {
    if (!storyblok) return function () {};
    storyblok.on(['change', 'published'], handleChangeOrPublish);
    storyblok.on('input', handleInput); // storyblok.on(
    //   [
    //     'input',
    //     'change',
    //     'published',
    //     'unpublished',
    //     'enterEditmode',
    //     'customEvent'
    //   ],
    //   event => console.debug(`[SBBridge:${event.action}]`, event)
    // )

    storyblok.pingEditor(function () {
      if (storyblok.inEditor) {
        setIsInEditor(true);
        storyblok.enterEditmode();
      }
    });
    return function () {// There is no event unsubscribe api ??
      // storyblok.off(['change', 'published'], handleChangeOrPublish)
      // storyblok.off('input', handleInput)
    };
  }, [handleChangeOrPublish, handleInput, storyblok]);
  return {
    story: story,
    loadStory: loadStory,
    setupEditor: setupEditor,
    isInEditor: isInEditor
  };
}

function useStoryblokEditor(slug) {
  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      storyblok = _useState6[0],
      setStoryblok = _useState6[1];

  var _useStory = useStory(storyblok),
      story = _useStory.story,
      loadStory = _useStory.loadStory,
      setupEditor = _useStory.setupEditor,
      isInEditor = _useStory.isInEditor;

  (0, _react.useEffect)(function () {
    loadStoryblokBridge().then(function () {
      return setStoryblok(window.storyblok);
    });
  }, []);
  (0, _react.useEffect)(function () {
    loadStory(slug);
    var listeners = setupEditor();
    return function () {
      listeners();
    };
  }, [loadStory, setupEditor, slug]);
  return {
    story: story,
    storyblok: storyblok,
    isInEditor: isInEditor
  };
}

var _default = useStoryblokEditor;
exports["default"] = _default;